import React from 'react';
import Icon from '../../../components/AppIcon';

const ProjectInfo = ({ project }) => {
  return (
    <div className="bg-card rounded-lg border border-border p-6 elevation-1">
      <div className="flex items-start justify-between mb-4">
        <div className="space-y-1">
          <h1 className="text-2xl font-heading text-foreground">{project?.title}</h1>
          <p className="text-muted-foreground">{project?.description}</p>
        </div>
        <div className="flex items-center space-x-2 bg-accent/10 px-3 py-1 rounded-full">
          <div className="w-2 h-2 bg-accent rounded-full"></div>
          <span className="text-sm font-medium text-accent">Active</span>
        </div>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 pt-4 border-t border-border">
        <div className="flex items-center space-x-3">
          <div className="w-8 h-8 bg-muted rounded-lg flex items-center justify-center">
            <Icon name="User" size={16} color="var(--color-muted-foreground)" />
          </div>
          <div>
            <p className="text-xs text-muted-foreground">Client</p>
            <p className="text-sm font-medium text-foreground">{project?.clientName}</p>
          </div>
        </div>

        <div className="flex items-center space-x-3">
          <div className="w-8 h-8 bg-muted rounded-lg flex items-center justify-center">
            <Icon name="Calendar" size={16} color="var(--color-muted-foreground)" />
          </div>
          <div>
            <p className="text-xs text-muted-foreground">Created</p>
            <p className="text-sm font-medium text-foreground">{project?.createdAt}</p>
          </div>
        </div>

        <div className="flex items-center space-x-3">
          <div className="w-8 h-8 bg-muted rounded-lg flex items-center justify-center">
            <Icon name="Gem" size={16} color="var(--color-accent)" />
          </div>
          <div>
            <p className="text-xs text-muted-foreground">Jeweler</p>
            <p className="text-sm font-medium text-foreground">{project?.jewelerName}</p>
          </div>
        </div>
      </div>
      {project?.message && (
        <div className="mt-6 pt-4 border-t border-border">
          <div className="bg-muted/50 rounded-lg p-4">
            <div className="flex items-start space-x-3">
              <div className="w-8 h-8 bg-accent/20 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                <Icon name="MessageCircle" size={16} color="var(--color-accent)" />
              </div>
              <div>
                <p className="text-sm font-medium text-foreground mb-1">Message from your jeweler:</p>
                <p className="text-sm text-muted-foreground leading-relaxed">{project?.message}</p>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ProjectInfo;